import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-300" data-id="element-92" data-mp="3gfsmscqd8umz">
      <div className="metal-rule h-1.5 w-full" aria-hidden="true" data-id="element-93" data-mp="3ggk90wy2pg0l" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-94" data-mp="32ovukn0cqfgg">
        <p className="metal-text text-lg font-extrabold uppercase" data-id="element-95" data-mp="36p6dt1d5n2d9">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-96" data-mp="3uf0phflqmkvx">Created by industrial instrumentation education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-slate-400/20 pt-6 text-xs" data-id="element-97" data-mp="39904ifsbca6">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}